import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ProductSelection from './pages/ProductSelection';
import Certifications from './pages/Certifications';
import CourseResourceConfirm from './pages/CourseResourceConfirm';
import CreateAssignments from './pages/CreateAssignments';
import CustomExams from './pages/CustomExams';
import Home from './pages/Home';
import CourseResourceSelect from './pages/CourseResourceSelect';
import Sync from './pages/SyncGrades';
import Settings from './pages/Settings';
export var Routes;
(function (Routes) {
    Routes["HOME"] = "/home";
    Routes["SELECT"] = "/select";
    Routes["CONFIRM"] = "/confirm";
    Routes["CREATE_ASSIGNMENTS"] = "/createassignments";
    Routes["BROWSE"] = "/browse";
    Routes["CUSTOM_EXAMS"] = "/customexams";
    Routes["CERTIFICATIONS"] = "/certifications";
    Routes["SYNC"] = "/sync";
    Routes["SETTINGS"] = "/settings";
})(Routes || (Routes = {}));
export default class Routing extends React.Component {
    render() {
        return (React.createElement(Switch, null,
            React.createElement(Route, { exact: true, path: Routes.HOME, component: Home }),
            React.createElement(Route, { exact: true, path: Routes.SELECT, component: CourseResourceSelect }),
            React.createElement(Route, { exact: true, path: Routes.CONFIRM, component: CourseResourceConfirm }),
            React.createElement(Route, { exact: true, path: Routes.CREATE_ASSIGNMENTS, component: CreateAssignments }),
            React.createElement(Route, { exact: true, path: Routes.BROWSE, component: ProductSelection }),
            React.createElement(Route, { exact: true, path: Routes.CUSTOM_EXAMS, component: CustomExams }),
            React.createElement(Route, { exact: true, path: Routes.CERTIFICATIONS, component: Certifications }),
            React.createElement(Route, { exact: true, path: Routes.SYNC, component: Sync }),
            React.createElement(Route, { exact: true, path: Routes.SETTINGS, component: Settings }),
            React.createElement(Route, { path: '*', component: Home })));
    }
}
//# sourceMappingURL=Routing.js.map